module.exports = __webpack_public_path__ + "img/num_17.437a7aec.png";